/**
 * FCT Account API
 * FCT Account API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: areche@ilernaonline.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NewStaticsResponseMeta from './NewStaticsResponseMeta';
import NewStaticsResponseTemplates from './NewStaticsResponseTemplates';

/**
 * The NewStaticsResponse model module.
 * @module model/NewStaticsResponse
 * @version 1.0.0
 */
class NewStaticsResponse {
    /**
     * Constructs a new <code>NewStaticsResponse</code>.
     * @alias module:model/NewStaticsResponse
     */
    constructor() { 
        
        NewStaticsResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NewStaticsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NewStaticsResponse} obj Optional instance to populate.
     * @return {module:model/NewStaticsResponse} The populated <code>NewStaticsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NewStaticsResponse();

            if (data.hasOwnProperty('templates')) {
                obj['templates'] = NewStaticsResponseTemplates.constructFromObject(data['templates']);
            }
            if (data.hasOwnProperty('_meta')) {
                obj['_meta'] = NewStaticsResponseMeta.constructFromObject(data['_meta']);
            }
        }
        return obj;
    }


}

/**
 * @member {module:model/NewStaticsResponseTemplates} templates
 */
NewStaticsResponse.prototype['templates'] = undefined;

/**
 * @member {module:model/NewStaticsResponseMeta} _meta
 */
NewStaticsResponse.prototype['_meta'] = undefined;






export default NewStaticsResponse;

